<template>
  <div class="page-factory">
    <HistoryOrderModal
      :visible="historyOrderModal"
      :item="{ personId: user.id }"
      @cancel="historyOrderModal = false"
      @ok="onHistoryOrderOk"
    />
    <div class="page-contentF">
      <a-layout>
        <div class="page-faHder">
          <a-layout-header>
            <div class="page-tabF">
              <a-tabs :defaultActiveKey="tabKey" @change="callback">
                <a-tab-pane
                  :tab="$tc('lang.menuList.Product_Inspection')"
                  key="1"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.menuList.Factory_Assessment')"
                  key="2"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.menuList.Loading_Supervision')"
                  key="3"
                ></a-tab-pane>
              </a-tabs>
            </div>
          </a-layout-header>
        </div>
        <a-layout>
          <div class="page-siderF">
            <a-layout-sider>
              <div class="page-imageFay" />
              <p class="page-pFactory">
                {{ $tc('lang.menuGoodsSpace.Factory_Evaluation') }}
              </p>
              <p class="page-spnFactory">
                &nbsp;&nbsp;&nbsp;&nbsp;{{
                  $tc('lang.menuGoodsSpace.Minder_provides_professional')
                }}
              </p>
            </a-layout-sider>
          </div>
          <div class="page-coFactory">
            <a-layout-content>
              <!--左侧头部-->
              <div class="page-hedrFactory">
                <img src="./image/choutHer.jpg" class="page-imgChoutF" />
                <p class="page-ppF">
                  {{ $tc('lang.menuGoodsSpace.Factory_Evaluation') }}
                </p>
              </div>
              <div class="page-hdF" />
              <!--==============语言切换==================-->
              <div class="page-langGd">
                <span style="float: left; margin-top: 0.7vh"
                  >{{ $tc('lang.menuGoodsSpace.Language') }} * :</span
                >
                <div class="page-butonGd">
                  <a-button
                    :type="orderReporttype === '1' ? 'primary' : 'default'"
                    class="page-rightButon"
                    @click="getLang('1')"
                    >{{ $tc('lang.menuGoodsSpace.Chinese') }}</a-button
                  >
                  <span class="page-span-renb">￥799/$115</span>
                  <a-button
                    :type="orderReporttype === '2' ? 'primary' : 'default'"
                    @click="getLang('2')"
                    >{{ $tc('lang.menuGoodsSpace.English') }}</a-button
                  >
                  <span class="page-span-renb">￥899/$139</span>
                </div>
              </div>
              <!--==============工厂信息==================-->
              <div class="page-Sup-form">
                <span class="span-gongTital"
                  >{{
                    $tc('lang.menuGoodsSpace.Vendor_Information')
                  }}&nbsp;&nbsp;&nbsp;<a
                    @click="historyOrderModal = !historyOrderModal"
                    style="float: right; color: #2196f3; font-size: 14px"
                    >{{ $tc('lang.menuGoodsSpace.history_orders') }}</a
                  ></span
                >
                <div class="page-hd" />
                <a-form
                  :form="forms"
                  @submit="handleSubmit"
                  class="page-suFrom"
                >
                  <a-form-item :label="$tc('lang.menuGoodsSpace.Vendor_Name')">
                    <a-input
                      :placeholder="$tc('lang.menuGoodsSpace.Factory_Cn')"
                      class="batton-style"
                      v-decorator="[
                        'orderFactoryname',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc('lang.menuGoodsSpace.Factory_Cn'),
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.menuGoodsSpace.Region')"
                    v-if="$i18n.locale === 'zh-CN'"
                  >
                    <a-cascader
                      :options="preCiy"
                      :placeholder="
                        $tc('lang.menuGoodsSpace.Please_fill_in_the_region')
                      "
                      class="batton-style"
                      @change="onAreaChange"
                      changeOnSelect
                      v-decorator="[
                        'orderFactoryarea',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc(
                                'lang.menuGoodsSpace.Please_fill_in_the_region',
                              ),
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.menuGoodsSpace.Vendor_Address')"
                  >
                    <a-input
                      :placeholder="
                        $tc('lang.menuGoodsSpace.Vendor_Address_text')
                      "
                      class="batton-style"
                      v-decorator="[
                        'orderFactoryaddress',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc(
                                'lang.menuGoodsSpace.Vendor_Address_text',
                              ),
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                  <div class="page-form-oneself">
                    <a-form-item
                      :label="$tc('lang.menuGoodsSpace.Contact_Name')"
                    >
                      <a-input
                        :placeholder="
                          $tc('lang.menuGoodsSpace.Please_contact_name')
                        "
                        class="batton-style"
                        v-decorator="['orderFactoryperson']"
                      />
                    </a-form-item>
                    <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
                      <a-input
                        :placeholder="
                          $tc('lang.menuGoodsSpace.Please_Telephone_number')
                        "
                        class="batton-style"
                        v-decorator="['orderFactoryfixedtel']"
                      />
                    </a-form-item>
                  </div>
                  <div class="page-form-oneself">
                    <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
                      <div class="page-mobile-input">
                        <a-input
                          :placeholder="
                            $tc('lang.menuGoodsSpace.Please_mobile_number')
                          "
                          v-decorator="[
                            'orderFactorytel',
                            {
                              rules: [
                                {
                                  required: true,
                                  message: $tc(
                                    'lang.menuGoodsSpace.Please_mobile_number',
                                  ),
                                },
                                // {
                                //   validator: $checking.validateMobilePhone,
                                // },
                              ],
                            },
                          ]"
                        />
                      </div>
                    </a-form-item>
                    <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
                      <a-input
                        :placeholder="
                          $tc('lang.menuGoodsSpace.Please_E_mail_Add')
                        "
                        class="batton-style"
                        v-decorator="['orderFactoryemail']"
                      />
                    </a-form-item>
                  </div>
                </a-form>
              </div>
              <!--==============我的信息==================-->
              <div class="page-Sup-form">
                <span class="span-gongTital"
                  >{{
                    $tc('lang.menuGoodsSpace.Company_Profile')
                  }}&nbsp;&nbsp;&nbsp;</span
                >
                <div class="page-hd" />
                <a-form
                  :form="forms"
                  @submit="handleSubmit"
                  class="page-suFrom"
                >
                  <a-form-item :label="$tc('lang.menuGoodsSpace.Company_Name')">
                    <a-input
                      :placeholder="
                        $tc('lang.menuGoodsSpace.Please_company_Name')
                      "
                      v-decorator="[
                        'orderTrustcompany',
                        {
                          rules: [
                            {
                              required: true,
                              message: $tc(
                                'lang.menuGoodsSpace.Please_company_Name',
                              ),
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item
                    :label="$tc('lang.menuGoodsSpace.Company_Address')"
                  >
                    <a-input
                      :placeholder="
                        $tc('lang.menuGoodsSpace.Please_company_Address')
                      "
                      v-decorator="['orderTrustaddress']"
                    />
                  </a-form-item>
                  <div class="page-form-oneself">
                    <a-form-item
                      :label="$tc('lang.menuGoodsSpace.Contact_Name')"
                    >
                      <a-input
                        :placeholder="
                          $tc('lang.menuGoodsSpace.Please_contact_name')
                        "
                        v-decorator="['orderTrustperson']"
                      />
                    </a-form-item>
                    <a-form-item :label="$tc('lang.menuGoodsSpace.Telephone')">
                      <a-input
                        :placeholder="
                          $tc('lang.menuGoodsSpace.Please_Telephone_number')
                        "
                        v-decorator="['orderTrustfixedtel']"
                      />
                    </a-form-item>
                  </div>
                  <div class="page-form-oneself">
                    <a-form-item :label="$tc('lang.menuGoodsSpace.Mobile')">
                      <div class="page-mobile-input">
                        <a-input
                          :placeholder="
                            $tc('lang.menuGoodsSpace.Please_mobile_number')
                          "
                          v-decorator="[
                            'orderTrusttel',
                            {
                              rules: [
                                {
                                  required: true,
                                  message: $tc(
                                    'lang.menuGoodsSpace.Please_mobile_number',
                                  ),
                                },
                                // {
                                //   validator: $checking.validateMobilePhone,
                                // },
                              ],
                            },
                          ]"
                        />
                      </div>
                    </a-form-item>
                    <a-form-item :label="$tc('lang.menuGoodsSpace.E_mail')">
                      <a-input
                        :placeholder="
                          $tc('lang.menuGoodsSpace.Please_E_mail_Add')
                        "
                        v-decorator="['orderTrustemail']"
                      />
                    </a-form-item>
                  </div>
                </a-form>
              </div>
              <!--===============监装时间======================-->
              <div class="page-Sup-form">
                <span class="span-gongTital"
                  >{{
                    $tc('lang.menuGoodsSpace.Inspection_Date')
                  }}&nbsp;&nbsp;&nbsp;</span
                >
                <div class="page-hd" />
                <a-form
                  :form="forms"
                  @submit="handleSubmit"
                  class="page-suFrom-One"
                >
                  <div>
                    <a-form-item>
                      <a-date-picker
                        :disabledDate="disabledDate"
                        @change="onDateChange"
                        :placeholder="$tc('lang.menuGoodsSpace.Select_date')"
                        v-decorator="[
                          'orderServicedate',
                          {
                            rules: [
                              {
                                required: true,
                                message: $tc('lang.menuGoodsSpace.Select_date'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <span
                    style="color: rgba(195, 195, 195, 1); margin-right: 10%"
                  >
                    {{ $tc('lang.menuGoodsSpace.Please_select_estimated') }}
                  </span>
                </a-form>
              </div>
              <!--===============检验资料======================-->
              <div class="page-Sup-form">
                <span class="span-gongTital"
                  >{{
                    $tc('lang.menuGoodsSpace.inspection_files')
                  }}&nbsp;&nbsp;&nbsp;</span
                >
                <div class="page-hd" />
                <a-form
                  :form="forms"
                  @submit="handleSubmit"
                  class="page-suFrom-One"
                >
                  <a-form-item style="text-align: left; width: 100%">
                    <div class="page-inpt-te">
                      <a-upload
                        :data="upled"
                        :action="config.urlImg + urlName"
                        :fileList="fileList"
                        @change="handleChangeUpload"
                        :multiple="true"
                      >
                        <a-button>
                          <a-icon type="upload" />
                          {{ $tc('lang.menuGoodsSpace.upload') }}
                        </a-button>
                      </a-upload>
                    </div>
                    <span style="color: rgba(195, 195, 195, 1)">
                      {{ $tc('lang.menuGoodsSpace.upload_text') }}
                    </span>
                  </a-form-item>
                </a-form>
              </div>
              <!--===============特别注意点======================-->
              <div class="page-Sup-form">
                <span class="span-gongTital"
                  >{{
                    $tc('lang.menuGoodsSpace.Special_Attention')
                  }}&nbsp;&nbsp;&nbsp;</span
                >
                <div class="page-hd" />
                <a-form
                  :form="forms"
                  @submit="handleSubmit"
                  class="page-suFrom-One"
                >
                  <a-form-item>
                    <div class="page-inpt-te">
                      <a-textarea
                        :placeholder="
                          $tc('lang.menuGoodsSpace.Please_special_attention')
                        "
                        :autosize="{ minRows: 2, maxRows: 6 }"
                        v-decorator="['orderRequire']"
                      />
                    </div>
                  </a-form-item>
                </a-form>
              </div>
              <!--===============最后提交按钮======================-->
              <div class="page-su-form-subimt">
                <form
                  :form="forms"
                  @submit="handleSubmit"
                  class="page-suFrom-One"
                >
                  <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                    <div class="page-suSubmit">
                      <a-button type="primary" html-type="submit">
                        {{ $tc('lang.menuGoodsSpace.Generating_orders') }}
                      </a-button>
                      &nbsp; &nbsp; &nbsp;
                      <span class="page-suSpan" @click="handleSubmit(10)">
                        {{ $tc('lang.menuGoodsSpace.Add_to_draft') }}
                      </span>
                    </div>
                  </a-form-item>
                </form>
              </div>
            </a-layout-content>
          </div>
        </a-layout>
      </a-layout>
      <sup-from ref="supFrom" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import supFrom from './componentsFy/supFrom';
import HistoryOrderModal from '../.././components/HistoryOrderModal.vue';
export default {
  name: 'factory',
  components: {
    'sup-from': supFrom,
    HistoryOrderModal,
  },

  data() {
    return {
      /*==========菜单切换=============*/
      tabKey: '2',
      /*=============表单=============*/
      forms: this.$form.createForm(this),
      /*============城市联动===========*/
      options: [],
      /*=========上传附件数据===========*/
      fileList: [],
      urlName: '/hzwmj/media/fileUpload',
      // 附件上传所带的信息
      upled: {
        mediaName: '质量验厂',
        mediaType: '2',
        mediaDesc: 'order_annex',
      },
      /*===处理日期今天以前日期不可以选择===*/
      disabledDate(current) {
        console.log('current', current);
        // Can not select days before today and today
        return current && current < moment().subtract(1, 'days');
      },
      // 订单号
      orderIdFrom: '',

      lonBtnType: true,
      checkOutType: 'checkMill',
      historyOrderModal: false,
      user: JSON.parse(sessionStorage.getItem('user')) || {},
    };
  },
  // 数据状态处理全局
  computed: {
    // 语言切换
    orderReporttype: {
      get() {
        return this.$store.state.factory.orderReporttype;
      },
      set(value) {
        this.$store.commit('factory/save', {
          orderReporttype: value,
        });
      },
    },
    // 城市联动
    preCiy: {
      get() {
        return this.$store.state.downOrder.preCiy;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          preCiy: value,
        });
      },
    },
    // 表单提交全部数据
    containerData: {
      get() {
        return this.$store.state.factory.containerData;
      },
      set(value) {
        this.$store.commit('factory/save', {
          containerData: value,
        });
      },
    },
    // 监装下单返回数据
    dataOrder: {
      get() {
        return this.$store.state.factory.dataOrder;
      },
      set(value) {
        this.$store.commit('factory/save', {
          dataOrder: value,
        });
      },
    },
    // 监装订单保存草稿箱返回数据
    draftsState: {
      get() {
        console.log(
          'this.$store.state.factory.draftsState',
          this.$store.state.factory.draftsState,
        );
        return this.$store.state.factory.draftsState;
      },
      set(value) {
        this.$store.commit('factory/save', {
          draftsState: value,
        });
      },
    },
  },
  watch: {
    // 验货下单返回数据
    dataOrder: function (val) {
      console.log('===数据结果===', val);
      if (val === true) {
        this.forms.resetFields();
        console.log('===val===', val);
        this.$refs.supFrom.out();
        this.fileList = [];
        this.panes = [
          {
            title: this.$tc('lang.menuGoodsSpace.Please_special_attention'),
            content: 'Content of Tab 1',
            key: '1',
            closable: false,
          },
        ];
        this.activeKey = this.panes[0].key;
        this.formDataList = [];
        this.foProduct = {
          form1: this.$form.createForm(this),
        };
        this.$router.push('/factory');
      } else {
        this.$refs.supFrom.init();
      }
    },
    // 验货订单保存草稿箱返回数据
    draftsState: function (val) {
      console.log('===数据结果===', val);
      if (val === true) {
        // this.form.resetFields();
        this.forms.resetFields();
        console.log('===val===', val);
        this.$refs.startFrom.out();
        this.fileList = [];
        this.formDataList = [];
        this.foProduct = {
          form1: this.$form.createForm(this),
        };
        this.$router.push('/factory');
      }
    },
  },
  created() {
    // 查询城市联动
    this.$store.dispatch('downOrder/queryPreCiy');
    //获取页面
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
    // 获取订单数据
    if (theRequest.type === '2') {
      this.dataSuperList();
      this.orderIdFrom = theRequest.orderId;
    }
    // 获取用户sessionStorage信息
    if (sessionStorage.getItem('user') !== null) {
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
    }
    this.handUserNum();
  },
  methods: {
    //当前下单页面填充我的信息
    handUserNum() {
      console.log('===this.user===', this.user.personCompanyname);
      setTimeout(() => {
        this.forms.setFieldsValue({
          // 我的信息
          orderTrustcompany: this.user.personCompanyname,
          orderTrustaddress: this.user.personAddress,
          orderTrustperson: this.user.personContactname,
          orderTrustfixedtel: this.user.personFixedtel,
          orderTrusttel: this.user.personMobilephone,
          orderTrustemail: this.user.personEmail,
        });
      });
    },
    // 页面路由切换
    callback(key) {
      console.log(key);
      if (key === '1') {
        this.$router.push('/goods');
      }
      if (key === '2') {
        this.$router.push('/factory');
      }
      if (key === '3') {
        this.$router.push('/supervision');
      }
    },
    /*语言切换*/
    getLang(key) {
      //1（中文）、2（英文）
      if (key === '1') {
        this.orderReporttype = '1';
      }
      if (key === '2') {
        this.orderReporttype = '2';
      }
    },
    /*表单提交*/
    handleSubmit(e) {
      event.preventDefault();
      // 如果等于10进行保存草稿箱否则生存订单
      if (e === 10) {
        // // 循环遍历table表格数据
        // for (let i = 0; i < this.panes.length; i++) {
        //   const fromNum = 'form' + this.panes[i].key;
        //   this.foProduct[fromNum].validateFieldsAndScroll((err, values) => {
        //     //获取集装箱table数据
        //     if (!err) {
        //       this.formDataList.push(values);
        //     }
        //   });
        // }
        // 处理全部数据整合
        this.forms.validateFieldsAndScroll((err, values) => {
          if (!err) {
            // 全部数据整合
            this.containerData = {
              // 集装箱数据
              // tableData: this.formDataList,

              // 附件id
              fileListId: this.onFileList().fileId,
              // 其它全部表单数据
              formDataMap: values,
              // 语言类型
              orderReporttype: this.orderReporttype,
              // 保存草稿箱状态
              orState: e,
            };
          }
        });
        console.log('=====草稿箱全部数据存放=====', this.containerData);
      } else {
        // // 循环遍历table表格数据
        // this.formDataList = [];
        // for (let i = 0; i < this.panes.length; i++) {
        //   const fromNum = 'form' + this.panes[i].key;
        //   this.foProduct[fromNum].validateFieldsAndScroll((err, values) => {
        //     //获取集装箱table数据
        //     if (!err) {
        //       console.log('===panes==========', values);
        //       this.formDataList.push({
        //         orderId: values.orderId,
        //         productCount: values.productCount,
        //         productDate: moment(values.productDate).format('YYYY-MM-DD'),
        //         // productModelid: values.productModelid,
        //         // productName: values.productName,
        //         productModelid: `集装箱${i + 1}`,
        //         productName: `集装箱${i + 1}`,
        //         productUnit: values.productUnit,
        //       });
        //     }
        //   });
        // }
        // 处理全部数据整合
        this.forms.validateFieldsAndScroll((err, values) => {
          if (!err) {
            // 全部数据整合
            this.containerData = {
              // 集装箱数据
              // tableData: this.formDataList,

              // 附件信息
              fileArray: this.onFileList().fileArray,
              // 附件id
              fileId: this.onFileList().fileId,
              // 其它全部表单数据
              formDataMap: values,
              // 语言类型
              orderReporttype: this.orderReporttype,
              orderIdFrom: this.orderIdFrom,
            };
          }
        });
        // 生成订单时打开确认订单页面
        this.$refs.supFrom.init();
        console.log('=====全部数据存放=====', this.$refs);
      }
    },
    // 获取订单数据
    dataSuperList() {
      const url = window.location.href;
      const theRequest = new Object();
      // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
      if (url.indexOf('?') != -1) {
        //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
        const str = url.substr(url.indexOf('?') + 1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }
      this.loading = true;
      this.$http
        .post('/hzwmj/workorder/selectById', {
          id: theRequest.id,
        })
        .then((data) => {
          if (data != null) {
            const reastData = data.data;
            const workorder = reastData.workorder;
            const medias = reastData.medias;
            this.forms.setFieldsValue({
              // 工厂信息
              orderFactoryname: workorder.orderFactoryname,
              orderFactoryarea:
                workorder.orderFactoryarea !== null
                  ? workorder.orderFactoryarea.split('/')
                  : [],
              orderFactoryaddress: workorder.orderFactoryaddress,
              orderFactoryperson: workorder.orderFactoryperson,
              orderFactoryfixedtel: workorder.orderFactoryfixedtel,
              orderFactorytel: workorder.orderFactorytel,
              orderFactoryemail: workorder.orderFactoryemail,
              // 我的信息
              orderTrustcompany: workorder.orderTrustcompany,
              orderTrustaddress: workorder.orderTrustaddress,
              orderTrustperson: workorder.orderTrustperson,
              orderTrustfixedtel: workorder.orderTrustfixedtel,
              orderTrusttel: workorder.orderTrusttel,
              orderTrustemail: workorder.orderTrustemail,
              //验货时间
              orderServicedate:
                workorder.orderServicedate != null
                  ? moment(workorder.orderServicedate)
                  : null,
              //检验水平
              aql: workorder.orderLevel,
              //致命缺陷
              criterion: workorder.orderFataldefect,
              //严重缺陷
              serious: workorder.orderSeriousdefect,
              //轻微缺陷
              slight: workorder.orderMinordefect,
              // 客户要求
              orderRequire: workorder.orderRequire,
            });
            // 图片回显
            if (medias.length !== 0) {
              medias.forEach((value) => {
                const urlPath = this.config.urlImg + value.mediaPath;
                this.fileList.push({
                  uid: value.id,
                  name: value.mediaName,
                  url: urlPath,
                  status: 'done',
                });
              });
            }
            // 添加产品数据
            // const products = reastData.products;
            // const newFoProduct = {};
            // const panes = [];
            // products.forEach((item, index) => {
            //   const activeKey = (this.newTabIndex += index);
            //   console.log('==activeKey========', activeKey);
            //   panes.push({
            //     title: this.$tc('lang.menuGoodsSpace.product') + `${activeKey}`,
            //     content: 'Content of new Tab',
            //     key: activeKey,
            //   });
            //   this.activeKey = activeKey;
            //   /*添加时候添加form表单数据处理*/
            //   let formAs = 'form' + activeKey;
            //   console.log('==formAs========', formAs);
            //   newFoProduct[formAs] = this.$form.createForm(this);
            // });
            // this.foProduct = newFoProduct;
            // console.log('products', products);
            // this.panes = panes;
            // setTimeout(() => {
            //   products.forEach((item, index) => {
            //     console.log('products', products);
            //     let formAs = 'form' + (index + 1);
            //     this.foProduct[formAs].setFieldsValue({
            //       productName: item.productName,
            //       productModelid: item.productModelid,
            //       orderId: item.productOrderid,
            //       productCount: item.productCount,
            //       productUnit: item.productUnit,
            //       productDate:
            //         item.productArrivedate != null
            //           ? moment(item.productArrivedate)
            //           : null,
            //     });
            //     console.log('this.foProduct', this.foProduct);
            //   });
            // });
          }
        })
        .catch(() => {
          console.log('12313');
        });
    },
    // 日期处理
    moment,
    onDateChange(dates, dateStrings) {
      console.log('From: ', dates[0], ', to: ', dates[1]);
      console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    },
    /*上传附件*/
    /*上传附件*/
    handleChangeUpload(info) {
      console.log('===info===', info);
      let fileList = [...info.fileList];
      // 从响应读取并显示文件链接
      fileList = fileList.map((file) => {
        if (file.response) {
          // 组件将file.url显示为链接
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;
    },
    // 遍历生产订单上传附件的ID
    onFileList() {
      let file = [];
      const fileList = this.fileList;
      console.log('this.fileList', this.fileList);
      if (fileList.length > 0) {
        fileList.forEach((value) => {
          if (value.response !== undefined) {
            file.push(value.response.data.object.id);
          } else {
            file.push(value.uid);
          }
        });
        console.log('file', file);
        const fileProd = {
          fileId: file.join(','),
          fileArray: fileList,
        };
        return fileProd;
      } else {
        return '';
      }
    },
    /*检验时间*/
    onDate(date, dateString) {
      console.log(date, dateString);
    },
    /*下拉*/
    handleChange(value) {
      // this.add()
      console.log(`selected ${value}`);
    },
    /*所在区域联动*/
    onAreaChange(value) {
      console.log(value);
    },
    /**
     * 选择历史订单数据
     */
    async onHistoryOrderOk(workorder) {
      console.log('onHistoryOrderOk', workorder);
      this.forms.setFieldsValue({
        // 工厂信息
        orderFactoryname: workorder.orderFactoryname,
        orderFactoryarea:
          workorder.orderFactoryarea !== null
            ? workorder.orderFactoryarea.split('/')
            : [],
        orderFactoryaddress: workorder.orderFactoryaddress,
        orderFactoryperson: workorder.orderFactoryperson,
        orderFactoryfixedtel: workorder.orderFactoryfixedtel,
        orderFactorytel: workorder.orderFactorytel,
        orderFactoryemail: workorder.orderFactoryemail,
      });
      this.historyOrderModal = false;
    },
  },
};
</script>

<style lang="less">
.page-factory {
  .page-contentF {
    border-left: 3px solid #f0f2f5;
    border-right: 2px solid #f0f2f5;
    border-bottom: 2px solid #a7a7a7;
    border-radius: 10px;
    margin-top: 3%;
    .page-faHder {
      .ant-layout-header {
        padding: 0 25px;
        background-color: #fff;
        height: 44px;
      }
    }
    .ant-layout {
      height: calc(100vh - 209px);
    }
    .page-tabF {
      .ant-tabs-nav .ant-tabs-tab-active {
        background-color: #e9eef3;
      }
      .ant-tabs-nav {
        float: left;
      }
    }
    .page-siderF {
      overflow-y: auto;
      background: #fff;
      width: 250px;
      padding: 20px;
      .ant-layout-sider {
        background-color: #fff;
      }
      .page-imageFay {
        margin-top: 40%;
        // margin-left: 18%;
        height: 163px;
        width: 186px;
        background-size: 100%;
        background-image: url(./image/factory2x.png);
      }
      .page-spnFactory {
        color: rgba(155, 150, 150, 1);
        font-size: 16px;
        // margin-left: 15%;
        width: 100%;
      }
      .page-pFactory {
        padding-top: 30px;
        font-size: 30px;
        /*margin-left: 25%;*/
        // margin-left: 31%;
        font-weight: 800;
        color: rgba(80, 80, 80, 1);
      }
    }
    /*左侧样式*/
    .page-coFactory {
      overflow-y: auto;
      background-color: #f5f5f5;
      width: 89%;
      /*左侧头部*/
      .page-hdF {
        border-bottom: 1px solid #a7a7a7;
        width: 95%;
        margin: 1px auto;
      }
      .page-hedrFactory {
        display: flex;
        .page-ppF {
          margin-top: 18px;
          font-weight: 900;
          font-size: 21px;
        }
        .page-imgChoutF {
          height: 60px;
          width: 60px;
          margin-left: 26px;
        }
      }
      /*左侧内容*/
      // .page-mainFactory {
      //   .page-rightF {
      //     .page-langF {
      //       padding-top: 2%;
      //       padding-left: 5%;
      //       .page-butonF {
      //         padding: 0 50px;
      //         display: flex;
      //         .ant-btn-primary {
      //           border-radius: 27px;
      //           width: 51px;
      //           background-color: #979797;
      //           border-color: #979797;
      //         }
      //         .ant-btn {
      //           border-radius: 27px;
      //           width: 51px;
      //         }
      //         .ant-btn > span {
      //           margin-left: -30%;
      //         }
      //         .page-rightFactory {
      //           margin-right: 30px;
      //         }
      //       }
      //     }
      //   }
      //   .page-caseF {
      //     padding-top: 1%;
      //     padding-left: 5%;
      //     .page-btF {
      //       padding: 0 50px;
      //       display: flex;
      //       .ant-btn-primary {
      //         border-radius: 27px;
      //         width: 51px;
      //         background-color: #979797;
      //         border-color: #979797;
      //       }
      //       .ant-btn {
      //         border-radius: 27px;
      //         width: 95px;
      //       }
      //       .page-rightButonF {
      //         margin-right: 30px;
      //       }
      //     }
      //   }
      // }
    }
  }
  /*左侧语言切换样式*/
  .page-langGd {
    padding-top: 2%;
    padding-left: 5%;
    .page-butonGd {
      padding: 0 50px;
      display: flex;
      .ant-btn-primary {
        border-radius: 27px;
        width: 51px;
        //background-color: #979797;
        background: linear-gradient(to right bottom, #3682c1, #0c3281);
        border-color: #979797;
      }
      .ant-btn {
        border-radius: 27px;
        width: 62px;
      }
      .ant-btn > span {
        margin-left: -30%;
      }
      .page-rightButon {
      }
      .page-span-renb {
        margin-right: 30px;
        margin-top: 5px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
  .page-langGd {
    padding-top: 2%;
    padding-left: 5%;
    .page-butonGd {
      padding: 0 50px;
      display: flex;
      .ant-btn-primary {
        border-radius: 27px;
        width: 51px;
        //background-color: #979797;
        background: linear-gradient(to right bottom, #3682c1, #0c3281);
        border-color: #979797;
      }
      .ant-btn {
        border-radius: 27px;
        width: 62px;
      }
      .ant-btn > span {
        margin-left: -30%;
      }
      .page-rightButon {
      }
      .page-span-renb {
        margin-right: 30px;
        margin-top: 5px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
  /*左侧语言下面内容*样式*/
  .page-mainSuperion {
    .page-leftS {
      .page-langS {
        padding-top: 2%;
        padding-left: 5%;
        .page-butonS {
          padding: 0 50px;
          display: flex;
          .ant-btn-primary {
            border-radius: 27px;
            width: 51px;
            background: linear-gradient(to right bottom, #3682c1, #0c3281);
            border-color: #979797;
          }
          .ant-btn {
            border-radius: 27px;
            width: 62px;
          }
          .ant-btn > span {
            margin-left: -30%;
          }
          .page-rightSuperion {
            /*margin-right: 30px;*/
          }
          .page-span-renb {
            margin-right: 30px;
            margin-top: 5px;
            color: rgba(0, 0, 0, 0.45);
          }
        }
      }
    }
  }
  /*表格样式*/
  .page-Sup-form {
    border-radius: 8px;
    width: 95%;
    margin-top: 3%;
    margin-bottom: 20px;
    margin-left: 3%;
    background-color: #ffffff;
    .ant-form-item {
      margin-bottom: 5px;
    }
    .page-hd {
      border-bottom: 1px solid #a7a7a7;
      width: 95%;
      margin: 1px auto;
      text-align: left;
    }
    .span-gongTital {
      width: 91%;
      text-align: left;
      display: inline-block;
      line-height: 50px;
      font-size: 17px;
      color: #67c23a;
      margin-left: 30px;
    }
    .ant-row {
      display: flex;
      width: 50%;
    }
    .page-suFrom-One {
      flex-grow: 1;
      margin: 20px 20%;
      .ant-form-item-control-wrapper {
        flex-grow: 0;
      }
      .page-inpt-te {
        //margin: 0 4%;
        width: 360px;
        padding-bottom: 20px;
        .ant-upload-list {
          width: 100%;
        }
        .ant-input {
          border-radius: 10px;
          height: 100px;
        }
      }
    }
    .page-suFrom {
      .span-standard {
        width: 100%;
        .ant-form-item-control {
          text-align: left;
        }
      }
      margin-top: 5px;
      padding-left: 2%;
      .ant-form-item-label {
        width: 130px;
        text-align: left;
        flex-shrink: 1;
      }
      flex-grow: 1;
      //padding-top: 60px;
      .batton-style {
        //margin-left: 10px;
      }
      .page-tabSu {
        //.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive, .ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive {
        //
        //}
        width: 60%;
        padding-left: 6%;
        .ant-tabs-card-bar {
          display: flex;
        }
        .ant-tabs-extra-content {
          clear: right !important;
        }
        .ant-form-item-label {
          width: 140px;
          text-align: left;
        }
        .ant-form-item {
          flex-shrink: 0;
        }
        /*加号*/
        .ant-row {
          display: flex;
          width: 100%;
        }
        /*table*/
        .ant-tabs-nav-container {
          order: -1;
        }
        .page-number-num {
          .ant-input-number {
            width: 100%;
          }
        }
        .page-danwei {
          width: 100%;
          .ant-form-item-children {
            display: flex;
          }
          .ant-input-number {
            //width: 230px;
            flex-grow: 1;
          }
          .page-unitName {
            //width: 105px;
            margin-top: -4px;
            width: 80px;
            flex-shrink: 0;
          }
        }
      }
      .page-select-su {
        > span {
          width: 70px;
          display: inline-block;
          flex-shrink: 0;
        }
        display: flex;
        //width: 200px;
      }
    }
    .ant-form-item {
      padding: 0 4%;
      flex-shrink: 0;
    }
    .ant-form-item-control-wrapper {
      flex-grow: 1;
    }
    /*工厂信息样式*/
    .page-form-oneself {
      .page-mobile-input {
        //width: 196px;
        //margin-left: 40px;
      }
      display: flex;
      //width: 70%;
    }
    /*最后按钮提交生成订单*/
    .page-suSubmit {
      display: flex;
      width: 420px;
      .page-suSpan {
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
      }
      .ant-btn-primary {
        width: 330px;
        height: 41px;
        border-radius: 20px;
        background-color: rgba(39, 86, 138, 1);
        border-color: rgba(39, 86, 138, 1);
      }
    }
  }
  // 底部提交
  .page-su-form-subimt {
    .page-suFrom-One {
      flex-grow: 1;
      padding-top: 0;
      .page-inpt-te {
        .ant-upload-list {
          width: 50%;
        }
        .ant-input {
          border-radius: 10px;
          height: 100px;
        }
      }
    }
    /*最后按钮提交生成订单*/
    .page-suSubmit {
      display: flex;
      width: 440px;
      .page-suSpan {
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
      }
      .ant-btn-primary {
        width: 330px;
        height: 41px;
        border-radius: 20px;
        background-color: rgba(39, 86, 138, 1);
        border-color: rgba(39, 86, 138, 1);
      }
    }
  }
}
</style>
